import classNames from "classnames/bind";
import style from "./Avatar.module.css";
import image from "../../../../assets/images/Rectangle_5676.png";
import { memo } from "react";

const cx = classNames.bind(style);

function Avatar() {
    const src = localStorage.getItem('avatar');
    return (
        <img
            width="100%"
            style={{ objectFit: "cover", borderRadius: "50%", width: '100%', height: '100%' }}
            src={src ? `${process.env.REACT_APP_BASE_URL}${src}` : image}
            alt="avatar"
          />
    )
}

export default memo(Avatar);